import React, { useState } from "react";
import { IP } from "../../internalServer";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Phone";
import BloodtypeIcon from "@mui/icons-material/Bloodtype";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import WcIcon from "@mui/icons-material/Wc";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

function MyStudentsTable({
  rows,
  columns,
  setSelectedStudents,
  selectedStudents,
}) {
  const [viewStudentDetails, setViewStudentDetails] = useState(false);
  const [details, setDetails] = useState({});

  const handleSelectStudent = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id)
        ? prev.filter((studentId) => studentId !== id)
        : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedStudents.length === rows.length) {
      setSelectedStudents([]);
    } else {
      setSelectedStudents(rows.map((row) => row.id));
    }
  };

  const isAllSelected =
    rows.length > 0 && selectedStudents.length === rows.length;

  console.log(details, "details");

  function formatDate(dateStr) {
    if (!dateStr) return "-";
    const parts = dateStr.split("/");
    if (parts.length !== 3) return "-";
    const [day, month, year] = parts;
    const date = new Date(`${year}-${month}-${day}`);
    return !isNaN(date) ? date.toLocaleDateString("en-GB") : "-";
  }

  return (
    <div
      className="table-container"
      style={{
        overflow: "auto",
        height: "calc(100vh - 350px)",
        width: "100%",
      }}
    >
      <table
        className="custom-table"
        style={{
          width: "100%",
          tableLayout: "auto",
          borderCollapse: "collapse",
        }}
      >
        <thead
          style={{ backgroundColor: "#ffd8be", position: "sticky", top: "0" }}
        >
          <tr>
            <th
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
              Sr. No
            </th>
            {columns.map((col) => (
              <th key={col.accessor}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows && rows.length > 0 ? (
            rows.map((row, index) => (
              <tr
                key={row.id}
                style={{
                  textAlign: "center",
                  backgroundColor: (index + 1) % 2 === 0 ? "#ececec" : "white",
                }}
              >
                <td
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    justifyContent: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedStudents.includes(row.id)}
                    onChange={() => handleSelectStudent(row.id)}
                  />
                  {index + 1}
                </td>

                {columns.map((col) => {
                  if (col.accessor === "name") {
                    return (
                      <td
                        key={col.accessor}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setViewStudentDetails(true);
                          setDetails(row);
                        }}
                      >
                        <img
                          src={
                            row.profile_picture
                              ? IP + row.profile_picture
                              : row.gender === "M"
                              ? "/images/Student_boy_pic.png"
                              : "/images/Student_girl_pic.png"
                          }
                          alt="profile"
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src =
                              row.gender === "M"
                                ? "/images/Student_boy_pic.png"
                                : "/images/Student_girl_pic.png";
                          }}
                        />
                        <span>{row[col.accessor]}</span>
                      </td>
                    );
                  }
                  return <td key={col.accessor}>{row[col.accessor]}</td>;
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length + 1}>No Results Found</td>
            </tr>
          )}
        </tbody>
      </table>

      <Dialog
        open={viewStudentDetails}
        onClose={() => setViewStudentDetails(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, backgroundColor: "#fafafa" },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1976d2",
            color: "white",
            textAlign: "center",
            fontWeight: "bold",
            position: "relative",
          }}
        >
          Student Profile
          <IconButton
            aria-label="close"
            onClick={() => setViewStudentDetails(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="orange-scrollBar" sx={{ p: 3 }}>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            mb={3}
            gap={2}
          >
            <Avatar
              src={
                details.profile_picture
                  ? IP + details.profile_picture
                  : details.gender === "M"
                  ? "/images/Student_boy_pic.png"
                  : "/images/Student_girl_pic.png"
              }
              alt={details.name}
              sx={{ width: 80, height: 80, border: "3px solid #1976d2" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  details.gender === "M"
                    ? "/images/Student_boy_pic.png"
                    : "/images/Student_girl_pic.png";
              }}
            />
            <Box>
              <Typography variant="h5" fontWeight="bold">
                {details.name}
              </Typography>
              <Box display="flex" gap={1} mt={1}>
                <Box
                  sx={{
                    backgroundColor: details.isRegistered
                      ? "#4caf50"
                      : "#ff9800",
                    color: "white",
                    px: 1.5,
                    py: 0.3,
                    borderRadius: 2,
                    fontSize: "0.75rem",
                  }}
                >
                  {details.isRegistered ? "Registered" : "Not Registered"}
                </Box>
                <Box
                  sx={{
                    backgroundColor:
                      details.isSubscribed === 1 ? "#2196f3" : "#f44336",
                    color: "white",
                    px: 1.5,
                    py: 0.3,
                    borderRadius: 2,
                    fontSize: "0.75rem",
                  }}
                >
                  {details.isSubscribed === 1 ? "Subscribed" : "Not Subscribed"}
                </Box>
              </Box>
            </Box>
          </Box>

          <Grid container spacing={2}>
            {/* Personal Info */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: "#1976d2", mb: 1 }}>
                Personal Info
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <CalendarMonthIcon sx={{ fontSize: 16, mr: 1 }} />
                Date of Birth
              </Typography>
              <Typography>{formatDate(details.dateOfBirth)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <WcIcon sx={{ fontSize: 16, mr: 1 }} />
                Gender
              </Typography>
              <Typography>
                {details.gender === "M" ? "Male" : "Female"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <BloodtypeIcon sx={{ fontSize: 16, mr: 1 }} />
                Blood Group
              </Typography>
              <Typography>{details.bloodGroup || "-"}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Mother Tongue</Typography>
              <Typography>{details.motherTongue || "-"}</Typography>
            </Grid>

            {/* Contact Info */}
            <Grid item xs={12} mt={2}>
              <Typography variant="h6" sx={{ color: "#1976d2", mb: 1 }}>
                Contact Info
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <EmailIcon sx={{ fontSize: 16, mr: 1 }} />
                Email
              </Typography>
              <Typography>{details.email}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <PhoneIcon sx={{ fontSize: 16, mr: 1 }} />
                Mobile
              </Typography>
              <Typography>{details.mobileNumber}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <ContactEmergencyIcon sx={{ fontSize: 16, mr: 1 }} />
                Emergency Contact
              </Typography>
              <Typography>{`${details.emergencyContactName} (${details.emergencyContactNumber})`}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">
                <HomeIcon sx={{ fontSize: 16, mr: 1 }} />
                Address
              </Typography>
              <Typography>
                {details.address?.buildingNumber}, {details.address?.line1},{" "}
                {details.address?.line2}, {details.address?.city},{" "}
                {details.address?.state}
              </Typography>
            </Grid>

            {/* Parents Info */}
            <Grid item xs={12} mt={2}>
              <Typography variant="h6" sx={{ color: "#1976d2", mb: 1 }}>
                Parents
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Father</Typography>
              <Typography>{`${details.father?.name} (${details.father?.mobileNumber})`}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Mother</Typography>
              <Typography>{`${details.mother?.name} (${details.mother?.mobileNumber})`}</Typography>
            </Grid>

            {/* School Info */}
            <Grid item xs={12} mt={2}>
              <Typography variant="h6" sx={{ color: "#1976d2", mb: 1 }}>
                School Info
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Admission No</Typography>
              <Typography>{details.admissionNumber}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Academic Year</Typography>
              <Typography>{details.academicYear?.name}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Section</Typography>
              <Typography>{details.section?.name}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2">Standard</Typography>
              <Typography>{details.standard?.name}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default MyStudentsTable;
